import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BarChart } from '@mui/x-charts/BarChart';

import useNotification from '../../../core/hooks/use_notification';
import { getSalesByCategoryAction, getSalesByCategoryState } from '../../../features/stats/get_sales_by_category';
import { getSalesStatsNotificationData } from '../../../core/utils/notification_utils';
import { formatCompactCurrency, formatCurrency, formatNumber, truncateLabel, useChartColors } from './sales_analysis_utils';
import ChartCard from './chart_card';

const ROW_HEIGHT = 34;

const CategoryChart = ({ query }) => {
    const chartColors = useChartColors();
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const getSalesByCategory = useSelector(getSalesByCategoryState);

    useEffect(() => {
        dispatch(getSalesByCategoryAction(query))
            .then(response => showErrorMessage(getSalesStatsNotificationData(response)));
    }, [dispatch, query, showErrorMessage]);

    const rows = getSalesByCategory?.data || [];
    const total = rows.reduce((sum, row) => sum + Number(row?.revenue), 0);
    const dataset = rows.map(row => ({
        label: row?.type,
        revenue: Number(row?.revenue),
        quantity: row?.quantity,
        share: total > 0 ? (Number(row?.revenue) / total) * 100 : 0
    }));

    return (
        <ChartCard
            title="Sprzedaż według kategorii"
            subtitle="Obrót brutto i udział w sprzedaży"
            loading={ getSalesByCategory?.loading }
            empty={ dataset.length === 0 }
            height={ Math.max(120, dataset.length * ROW_HEIGHT + 48) }
        >
            {
                dataset.length > 0 && (
                    <BarChart
                        layout="horizontal"
                        dataset={ dataset }
                        series={ [{
                            dataKey: 'revenue',
                            label: 'Obrót',
                            color: chartColors.primary,
                            valueFormatter: (value, { dataIndex }) => {
                                const row = dataset[dataIndex];
                                return `${ formatCurrency(value) } (${ row?.share.toFixed(1).replace('.', ',') }%) · ${ formatNumber(row?.quantity) } szt.`;
                            }
                        }] }
                        yAxis={ [{ scaleType: 'band', dataKey: 'label', valueFormatter: (label, context) => context.location === 'tick' ? truncateLabel(label, 22) : label }] }
                        xAxis={ [{ valueFormatter: formatCompactCurrency, tickNumber: 5 }] }
                        grid={ { vertical: true } }
                        borderRadius={ 4 }
                        margin={ { left: 180, right: 40, top: 8, bottom: 32 } }
                        slotProps={ { legend: { hidden: true } } }
                    />
                )
            }
        </ChartCard>
    );
};

export default CategoryChart;
